import React from "react";
import Helpers from "../../helpers/helpers";
import "./common.css";
//Import Breadcrumb

const CustomLabel = ({ label, border, borderRadius, color, backgroundColor, height, marginLeft, marginRight, fontSize = 12, fontWeight, marginTop }) => {
    return (
        <React.Fragment>
            <div
                className={"label-container"}
                style={{
                    border: border,
                    borderRadius: borderRadius || 5,
                    color: color,
                    backgroundColor: backgroundColor,
                    margin: 0,
                    marginLeft: marginLeft || 0,
                    marginRight: marginRight || 0,
                    marginTop: marginTop || 0,
                    height: height || 'fit-content',
                    fontSize: fontSize || 12,
                    fontWeight: fontWeight || 500,
                }}>
                {label}
            </div>
        </React.Fragment>
    );
};

const StatusLabel = ({ label, marginLeft }) => {
    return (
        <React.Fragment>
            <div
                className={
                    ((Helpers.capitalize(label) === 'Active' || Helpers.capitalize(label) === 'Published') ? "status-label-active" :
                        "status-label-inactive") + " label-container"
                }
                style={{ marginLeft: marginLeft || 10 }}
            >{Helpers.capitalize(label)}</div>
        </React.Fragment>
    );
};


const StatusVoucherLabel = ({ label, marginLeft }) => {
    return (
        <React.Fragment>
            <div
                className={
                    (label === 'active' ? "status-label-active"
                        : label === "expired" ? "status-label-inactive"
                            : label === "assigned" ? "order-label-pending-order" : "item-label-configurable"
                    )
                    + " label-container"
                }
                style={{ marginLeft: marginLeft || 10 }}
            >{Helpers.capitalize(label)}</div>
        </React.Fragment>
    );
};


const StatusByIDLabel = ({ label, marginLeft }) => {
    return (
        <React.Fragment>
            <div
                className={
                    (label === 1 ? "status-label-active" :
                        "status-label-inactive") + " label-container"
                }
                style={{ marginLeft: marginLeft || 10 }}
            >{label === 1 ? "Active" : "Inactive"}</div>
        </React.Fragment>
    );
};

const ItemTag = ({ label, marginLeft }) => {
    return (
        <React.Fragment>
            <div
                className={
                    (label === 'configurable' ? "item-label-configurable " :
                        "status-label-active") + " label-container"}
                style={{ marginLeft: marginLeft || 10, maxHeight: 25 }}
            >{Helpers.capitalize(label)}</div>
        </React.Fragment>
    );
};

const PaymentStatusLabel = ({ label, marginLeft }) => {
    let labelText = label == "Pending" ? "Unpaid" : label;

    return (
        <React.Fragment>
            <div
                className={`payment-label-${label}` + " label-container"}
                style={{ marginLeft: marginLeft || 10 }}
            >
                {Helpers.capitalize(label)}
            </div>
        </React.Fragment>
    );
};

const FreeGiftLabel = ({ marginRight }) => {
    return (
        <React.Fragment>
            <div className={"free-gift-label label-container"} style={{ marginRight: marginRight || 10, marginLeft: 0 }}>Free Gift</div>
        </React.Fragment>
    );
};

const RefundedLabel = ({ marginLeft }) => {
    return (
        <React.Fragment>
            <div className={"refunded-label label-container"} style={{ marginLeft: marginLeft || 10 }}>Refunded</div>
        </React.Fragment>
    );
};

const SupportStatusLabel = ({ label, marginLeft }) => {
    return (
        <React.Fragment>
            <div
                className={(label === 'pending' ? "order-label-pending-order" : "status-label-active") + " label-container"}
                style={{ marginLeft: marginLeft || 10 }}
            >
                {Helpers.capitalize(label)}
            </div>
        </React.Fragment>
    );
};

const ProductStatusLabel = ({ label, marginLeft }) => {
    return (
        <React.Fragment>
            <div
                className={(label === 2 ? "product-label-pending-order" : label === 1 ? "status-label-active" : "status-label-inactive") + " label-container"}
                style={{ marginLeft: marginLeft || 10 }}
            >
                {Helpers.displayProductStatusString(label)}
            </div>
        </React.Fragment>
    );
};

const GeneralStatusLabel = ({ label, list = [], marginLeft, borderRadius }) => {
    let status = list?.find((item) => item.value == label);
    return (
        <React.Fragment>
            {
                status ?
                    <div
                        className={`${status.statusColor} label-container`}
                        style={{ marginLeft: marginLeft || 10, maxHeight: 25, borderRadius: borderRadius || 6 }}
                    >
                        {status.label}
                    </div> : "-"
            }

        </React.Fragment>
    );
};

const TaskStatusLabel = ({ label, marginLeft }) => {
    return (
        <React.Fragment>
            <div
                className={`task-${label}-label` + " label-container"}
                style={{ marginLeft: marginLeft || 10, maxHeight: 25 }}
            >
                {Helpers.displayTaskStatusString(label)}
            </div>
        </React.Fragment>
    );
};

const AssetStatusLabel = ({ label, marginLeft }) => {
    let status = Helpers.taskinvoiceStatus.find((item) => item.value == label);
    return (
        <React.Fragment>
            {
                status ?
                    <div
                        className={`${status.statusColor} label-container`}
                        style={{ marginLeft: marginLeft || 10, maxHeight: 25 }}
                    >
                        {status.label}
                    </div> : '-'
            }

        </React.Fragment>
    );
};

const ServiceStatusLabel = ({ label, marginLeft }) => {
    return (
        <React.Fragment>
            <div
                className={`service-${label}-label` + " label-container"}
                style={{ marginLeft: marginLeft || 10, maxHeight: 25 }}
            >
                {Helpers.capitalize(label)}
            </div>
        </React.Fragment>
    );
};

export default {
    CustomLabel,
    StatusVoucherLabel,
    ItemTag,
    StatusByIDLabel,
    PaymentStatusLabel,
    FreeGiftLabel,
    StatusLabel,
    RefundedLabel,
    SupportStatusLabel,
    ProductStatusLabel,
    GeneralStatusLabel,
    TaskStatusLabel,
    AssetStatusLabel,
    ServiceStatusLabel
};
